/** Primary first, then aliases, without duplicates. Mirrors server/services/mailboxFromPure.ts. */
export function mailboxFromChoices(
  primary: string | null | undefined,
  aliases: readonly string[] | null | undefined,
): string[] {
  const seen = new Set<string>();
  const choices: string[] = [];
  for (const value of [primary, ...(aliases ?? [])]) {
    const email = String(value ?? "").trim().toLowerCase();
    if (!email || seen.has(email)) continue;
    seen.add(email);
    choices.push(email);
  }
  return choices;
}

export function resolvedDefaultFrom(
  primary: string | null | undefined,
  aliases: readonly string[] | null | undefined,
  preferred: string | null | undefined,
): string {
  const choices = mailboxFromChoices(primary, aliases);
  const wanted = String(preferred ?? "").trim().toLowerCase();
  if (wanted && choices.includes(wanted)) return wanted;
  return choices[0] ?? String(primary ?? "").trim().toLowerCase();
}

export type ComposeFromOption = {
  key: string;
  accountId: string;
  email: string;
  label: string;
};

/** One row per sendable address. Aliases name the mailbox they belong to. */
export function composeFromOptions(
  accounts: ReadonlyArray<{
    id: string;
    email: string;
    email_aliases?: readonly string[] | null;
    is_private?: boolean;
  }>,
): ComposeFromOption[] {
  const options: ComposeFromOption[] = [];
  for (const account of accounts) {
    const primary = String(account.email ?? "").trim().toLowerCase();
    if (!primary) continue;
    for (const email of mailboxFromChoices(primary, account.email_aliases)) {
      const isAlias = email !== primary;
      const notes = [
        isAlias ? `Alias von ${primary}` : "",
        account.is_private ? "privat" : "",
      ].filter(Boolean);
      options.push({
        key: `${account.id}:${email}`,
        accountId: account.id,
        email,
        label: notes.length > 0 ? `${email} (${notes.join(", ")})` : email,
      });
    }
  }
  return options;
}
